import { render } from "./Users.vue?vue&type=template&id=cd733c2c"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Users.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd733c2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd733c2c', __exports__)) {
    api.reload('cd733c2c', __exports__)
  }
  
  module.hot.accept("./Users.vue?vue&type=template&id=cd733c2c", () => {
    api.rerender('cd733c2c', render)
  })

}


export default __exports__